import { Component, OnInit, Inject, Input, SimpleChanges, OnChanges, EventEmitter, Output } from '@angular/core';
import * as L from 'leaflet';

import { BaseComponent } from '~Interfaces/basecomponent';
import { FournisseurService } from '~Services/fournisseur.service';

/**
 * Composant de la fiche fournisseur
 * @extends BaseComponent
 * @implements OnInit, OnChanges
 */
@Component({
  selector: 'app-fiche-fournisseur',
  templateUrl: './fiche-fournisseur.component.html',
  styleUrls: ['./fiche-fournisseur.component.scss']
})
export class FicheFournisseurComponent extends BaseComponent implements OnInit, OnChanges {

    private icon = require('../../../assets/img/pointsrelais-pin.png');

    private carte;
    private carteInitialisee: boolean = false;

    @Input() codeFournisseur: string;
    fournisseur: any = null;

    @Output() fournisseurEvent: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Constructeur
     * @param fournisseurService
     */
    constructor(@Inject(FournisseurService) private fournisseurService: FournisseurService) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Changements du composant
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes.codeFournisseur && this.codeFournisseur) {
            this.fournisseur = null;
            this.carteInitialisee = false;
            this.fournisseurService.obtenirFournisseurFAST(this.codeFournisseur).subscribe((retour) => {
                if (retour && retour.Result) {
                    this.fournisseur = retour.Result;
                    this.fournisseurEvent.emit(this.fournisseur);
                }
            });
        }
    }

    /**
     * Ouvrir la popup de localisation
     */
    ouvrirPopupLocalisation(): boolean {
        // Afficher la carte ?
        if (this.possedeCoordonnees) {

            // Afficher la carte
            setTimeout(() => {
                this.afficherCarte();
            }, 10);
            
            return true;
        }
        return false;
    }

    /**
     * Afficher la carte
     */
    private afficherCarte() {
        // Initialiser la carte
        if (!this.carteInitialisee) {

            // Création de la carte
            this.carte = L.map('map');
            L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', { attribution: '© <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors' }).addTo(this.carte);

            // Zoom et position
            let zoom = 14;
            let position = this.obtenirPosition();

            // Définit la position de la carte
            this.carte.setView(position, zoom);

            // Ajouter le point sur la carte
            let icon = L.icon({
                iconUrl: this.icon,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            });
            L.marker(position, { icon: icon }).addTo(this.carte);

            // La carte est initialisée
            this.carteInitialisee = true;
        }
    }

    /**
     * Obtenir la position du fournisseur pour la carte
     */
    private obtenirPosition() {
        return L.latLng(this.fournisseur.AdressePrincipal.Latitude, this.fournisseur.AdressePrincipal.Longitude);;
    }

    /**
     * Indique si le fournisseur possède des coordonnées
     */
    private get possedeCoordonnees(): boolean {
        return this.fournisseur && this.fournisseur.AdressePrincipal && this.fournisseur.AdressePrincipal.Latitude && this.fournisseur.AdressePrincipal.Longitude;
    }
}
